import type { Revision } from "~/types/Revision";
import type { SubmittedDocument } from "~/types/SubmittedDocument";
import { DocumentState } from "~/types/enums/DocumentState";

export const isSubmittedComparisonDocument = (document: SubmittedDocument) =>
  [DocumentState.submitted, DocumentState.grading, DocumentState.graded].includes(document.state);

export const isSubmittedComparisonRevision = (revision: Partial<Revision>) =>
  revision.isArchived !== true && revision.studentSubmissionOps == null;
